import * as React from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../CustomButton";
import styles from "./DialogBox.module.css";

function CheckYourInbox({ open, setClose, onClick ,email}) {
  return (
    <Modal
      style={{ top: "10%" }}
      className={`${styles.dialogBox} text-center font-style-primary`}
      show={open}
      onHide={setClose}
    >
      <Modal.Header style={{ borderBottom: 0 }} closeButton></Modal.Header>
      <Modal.Title>
          <strong className="fs-4">Verify Your Email</strong>
        </Modal.Title>
      <Modal.Body>
        <p className="mt-4 p-sm-3 text-secondary text-center">
          We’ve sent a verification email to <span className="fw-bold text-black">{email}</span>.
          <br/>
          Please check your inbox, and if you don’t see it there, kindly check your spam or junk folders as well.
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0 mb-3">
        <CustomButton className={"m-0 px-5"} onClick={onClick}>Ok</CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default CheckYourInbox;
